import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
`;


export const Subtitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    display: flex;
    gap: 8px;
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
    max-width: 600px;
  `}
`;

export const AlertWrapper = styled.div`
  > div {
    align-items: center;
    padding: 0px;
  }
`;

export const HelpCenterWrapper = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};

    a {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const Circle = styled.span`
  ${({
    theme, hideOnMobile, displayOnMobile, hideOnDesktop,
  }) => css`
      align-items: center;
      background-color: ${theme.v2.colors.brand.primaryExtraDark};
      border-radius: 100%;
      color: ${theme.v2.colors.white.primary};
      display: inline-flex;
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xxs};
      font-weight: ${theme.v2.font.weights.bold};
      height: 10px;
      justify-content: center;
      padding: 10px;
      width: 10px;

      ${hideOnMobile && css`
        @media (max-width: ${theme.v2.breakpoints.sm}) {
          display: none;
        }
      `}

      ${hideOnDesktop && css`
        @media (min-width: ${theme.v2.breakpoints.sm}) {
          display: none;
        }
      `}

      ${displayOnMobile && css`
        @media (max-width: ${theme.v2.breakpoints.sm}) {
          display: inline-flex;
        }
      `}
  `}
`;

export const ContentRow = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    gap: 16px;
    justify-content: flex-start;
    max-width: 100%;
    padding: 20px;
    width: 100%;
    border-radius: 8px;
    background: ${theme.v2.colors.brand.primaryUltraLight};

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin-top: 16px;
    }
  `};
`;

export const ContentColumn = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 32px;
  justify-content: flex-start;
`;


export const HowToBackground = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.brand.primaryLowLight};
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    margin: 0px;
    padding:  32px;
  `}
`;

export const HowToTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
  `}
`;

export const Steps = styled.ol`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin: 16px 0px;
    padding: 0px;
    counter-reset: item;
    list-style: none;
  `}
`;

export const StepItem = styled.li`
  ${({ theme }) => css`
      align-items: flex-start;
      counter-increment: item;
      display: flex;
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xxs};
      font-weight: ${theme.v2.font.weights.regular};
      gap: 16px;
      justify-content: flex-start;
      max-width: calc(484px + 26px + 24px);

      &:before {
        align-items: center;
        background: ${theme.v2.colors.brand.primaryExtraDark};
        blex-basis: 24px;
        border-radius: 100%;
        color: ${theme.v2.colors.neutral.highPure};
        content: counter(item);
        display: flex;
        flex-shrink: 0;
        font-weight: ${theme.v2.font.weights.bold};
        height: 24px;
        justify-content: center;
        width: 24px;
    }
  `}
`;

export const StepContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const StepDescription = styled.span`
    ${({ theme }) => css`
        color: ${theme.v2.colors.neutral.lowPure};
        font-family: ${theme.v2.font.family.primary};
        font-size: ${theme.v2.font.sizes.xxs};
        font-weight: ${theme.v2.font.weights.regular};
        line-height: ${theme.v2.font.lineHeight.list};
        margin: 0px;
    `}
`;

export const StepAlertWrapper = styled.div`
    display: flex;

    > div {
     padding: 0px;
    }
`;

export const StepDnsBox = styled.div`
    ${({ theme }) => css`
      background-color: ${theme.v2.colors.brand.primaryUltraLight};
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      padding: 16px;
    `}
`;

export const StepDnsBoxRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;

export const StepDnsRow = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    padding: 16px;
    width: fit-content;
  `}
`;

export const StepLabel = styled.span`
    ${({ theme }) => css`
        color: ${theme.v2.colors.neutral.lowMedium};
        font-family: ${theme.v2.font.family.primary};
        font-size: ${theme.v2.font.sizes.xxs};
        font-weight: ${theme.v2.font.weights.regular};
        line-height: ${theme.v2.font.lineHeight.list};
    `}
`;

export const StepValue = styled.span`
    ${({ theme }) => css`
        color: ${theme.v2.colors.neutral.lowDark};
        font-family: ${theme.v2.font.family.primary};
        font-size: ${theme.v2.font.sizes.xxs};
        font-weight: ${theme.v2.font.weights.medium};
        line-height: ${theme.v2.font.lineHeight.list};
    `}
`;

export const ButtonWrapper = styled.div`
    display: block;
    padding: 0px 0px 0px 40px;
`;

export const ActionsRow = styled.div`
  ${({ theme }) => css`
    align-items: center;
    align-self: flex-end;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0px 20px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: unset;
      flex-direction: column-reverse;
      justify-content: unset;
      min-width: 100%;

      > span {
        display: flex;
        align-items: unset;
        justify-content: unset;
        min-width: 100%;

        button {
          min-width: 100%;
        }
      }
    }
    `}
`;

export const DnsContentRow = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-grow:1;
    gap: 16px;
    min-width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      min-width: auto;
    }
  `};
`;

export const ChevronWrapper = styled.div`
  ${({ theme }) => css`
    align-self: center;
    display: flex;
    margin-top: 16px;
    justify-content: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: auto;
      margin-top: 0;
      width: 100%;
    }
  `};
`;

export const DnsContentColumn = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }
  `};
`;

export const OriginalDnsContainer = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.neutral.highLight};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    height: 128px;
    justify-content: center;
    padding: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 8px;
      height: auto;
      width: 100%;
    }
  `}
`;

export const OriginalDnsLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    display: ruby;
    font-weight: ${theme.v2.font.weights.regular};
  `};
`;

export const OriginalDnsText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `};
`;

export const CheckboxLabel = styled.div`
  ${({ theme }) => css`
    cursor: pointer;
    display: flex;
    gap: 8px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0px 20px;
    }
  `};
`;
